import { useQuery } from "@apollo/client";
import { Query } from "@/app/graphql/codegen";
import { FETCH_CHATS } from "@chat/graphql/queries/fetchChats";
import { useMemo } from "react";

export const useLastModifiedChat = (excludeChatId?: string) => {
    const { data } = useQuery<Pick<Query, "chats">>(FETCH_CHATS);

    return useMemo(() => {
        if (!data?.chats) return null;

        return [...data.chats].filter((chat) => chat.id !== excludeChatId).sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())[0] ?? null;
    }, [data?.chats, excludeChatId]);
};
